<template>
    <div>
        <b-form-input v-model="contact.fullName" type="text" placeholder="nom"></b-form-input>
        <b-form-input v-model="contact.phone" type="tel" placeholder="téléphone"></b-form-input>
        <b-form-input v-model="contact.email" type="email" placeholder="email"></b-form-input>
        <b-form-input v-model="contact.fonction" type="text" placeholder="fonction"></b-form-input>
    </div>
</template>

<script>

  import bdd from '../../api/bdd'
  import debounce from 'debounce-promise'

  export default {

    name: 'Contact',

    props: ['id', 'new'],

    data() {
      return {
        contact: {
          fullName: '',
          phone: '',
          email: '',
          fonction: ''
        }
      }
    },

    created() {
      this.debouncedUpdateContact = debounce(this.updateContact, 800)
    },

    mounted() {
      if (!this.new) {
        bdd.getContact(this.id)
          .then(contact => {
            this.contact = contact
            this.watchContact()
            console.log('contact récupéré', this.id)
            this.$emit('update-contact', this.contact)
          })
      } else {
        console.log('création nouveau contact')
        this.watchContact()
      }
    },

    methods: {
      watchContact: function () {
        this.$watch(
          'contact', () => {
            this.debouncedUpdateContact()
          },
          {deep: true}
        )
      },
      updateContact: function () {
        return bdd.persistContact(this.id, this.contact)
          .then(response => {
            console.log('update contact', this.id, response)
            this.$emit('update-contact', this.contact)
          })
      }
    }

  }

</script>


// WEBPACK FOOTER //
// src/components/EditSub/Contact.vue